import type {MantineSize, ModalProps} from "@mantine/core";
import {Modal} from "@mantine/core";
import type {ReactNode} from "react";
import {twMerge} from "tailwind-merge";

export function GenericModal(
    props: ModalProps & {
        opened: boolean;
        onClose: () => void;
        title?: React.ReactNode | string;
        className?: string;
        children: ReactNode;
        size: MantineSize;
        hideLine?: boolean;
    },
) {
    const {classNames, hideLine: _hideLine, ...rest} = props;

    return (
        <Modal
            {...rest}
            className={twMerge("gj-text-body-300", props.className)}
            centered
            classNames={(theme, modalProps, context) => {
                const resolved = typeof classNames === "function"
                    ? classNames(theme, modalProps, context)
                    : (classNames ?? {});
                return {
                    ...resolved,
                    content: twMerge("!bg-ds-surface p-6 rounded-xl", resolved.content),
                    header: twMerge("!bg-ds-surface !p-0", resolved.header),
                    body: twMerge("!p-0", resolved.body),
                    title: resolved.title,
                };
            }}
        >
            {props.children}
        </Modal>
    );
}
